// OBS: Na UI (IntegrationConfigureModal.vue), sempre os DOIS ÚLTIMOS campos de cada schema
// serão exibidos lado a lado em uma única linha.

export default {
  docuware: [
    {
      key: 'server_url',
      label: 'integrations.docuware.server_url.label',
      type: 'url',
      required: true,
      placeholder: 'integrations.docuware.server_url.placeholder',
      icon: 'link',
    },
    {
      key: 'file_cabinet',
      label: 'integrations.docuware.file_cabinet.label',
      type: 'text',
      required: true,
      placeholder: 'integrations.docuware.file_cabinet.placeholder',
      icon: 'key',
    },
    {
      key: 'user',
      label: 'integrations.docuware.user.label',
      type: 'text',
      required: true,
      placeholder: 'integrations.docuware.user.placeholder',
      icon: 'user',
    },
    {
      key: 'password',
      label: 'integrations.docuware.password.label',
      type: 'password',
      required: true,
      placeholder: 'integrations.docuware.password.placeholder',
      icon: 'lock',
    },
  ],
};
